import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sbpro-page-header',
  templateUrl: './sbpro-page-header.component.html',
  styleUrls: ['./sbpro-page-header.component.scss', './devices.min.css']
})
export class SbproPageHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
